import { h } from "preact";
import { useState } from "preact/hooks";

import classname from "../../../foundation/utils/classname";
import ResponsiveImage from "../../ResponsiveImage";

import styles from "./AnimatedButton.module.css";

type AnimatedButtonProps = {
    class?: string;
    imageSrc: string;
    disabledImageSrc?: string;
    onClick?: () => void;
    disabled?: boolean;
};

const AnimatedButton: React.FC<AnimatedButtonProps> = ({
    class: cssClass,
    imageSrc,
    disabledImageSrc,
    onClick,
    disabled = false
}) => {
    const [selected, setSelected] = useState(false);

    function buttonClicked() {
        setSelected(true);
        onClick?.();
    }

    return (
        <div className={classname(styles.animatedButtonContainer, cssClass)}>
            <div className={classname(styles.animatedButtonSelectedBackground, { [styles.selected]: selected })}/>
            <button
                className={classname(styles.animatedButton, { [styles.disabled]: disabled })}
                onClick={buttonClicked}
                onFocus={() => setSelected(true)}
                onBlur={() => setSelected(false)}
                disabled={disabled}>
                <ResponsiveImage asset={disabled ? disabledImageSrc : imageSrc}/>
            </button>
        </div>
    );
};

export default AnimatedButton;
